import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-guidanceContent",
  "use": "icon-guidanceContent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-guidanceContent\"><path d=\"M887.239111 574.748444l-223.175111-430.648888C613.546667 53.873778 516.778667 0 405.048889 0a342.471111 342.471111 0 0 0-102.115556 15.758222L262.257778 30.890667s-43.918222 21.959111-60.245334 34.019555C67.015111 159.118222 16.782222 330.979556 91.648 464.896l248.832 412.046222 0.853333 1.592889C402.090667 969.614222 499.370667 1024 601.315556 1024c53.248 0 105.756444-14.165333 155.989333-42.211556 149.788444-83.399111 201.955556-246.954667 129.991111-407.04zM448.284444 371.939556a39.936 39.936 0 0 1-19.057777 24.348444 38.912 38.912 0 0 1-19.114667 4.835556c-16.327111 0-31.516444-9.443556-40.334222-25.031112l-66.787556-119.466666c-12.686222-22.698667-6.599111-49.493333 14.165334-61.041778 20.024889-11.036444 47.502222-1.706667 59.619555 19.968l66.787556 119.409778c6.314667 11.662222 8.192 25.031111 4.721777 36.977778z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/guidanceContent.svg
// module id = Zdez
// module chunks = 78